import { render, staticRenderFns } from "./CreateEditRichMenu.vue?vue&type=template&id=5f4916da"
import script from "./CreateEditRichMenu.vue?vue&type=script&lang=js"
export * from "./CreateEditRichMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f4916da')) {
      api.createRecord('5f4916da', component.options)
    } else {
      api.reload('5f4916da', component.options)
    }
    module.hot.accept("./CreateEditRichMenu.vue?vue&type=template&id=5f4916da", function () {
      api.rerender('5f4916da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/RichMenu/Modals/CreateEditRichMenu.vue"
export default component.exports